import { createContext } from 'react';

const RegistrationContext = createContext(null);
export default RegistrationContext;
